import React from 'react';
import clsx from 'clsx';

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
    className?: string;
}

export function UtilityButton({ children, className, ...props }: IProps) {
    return (
        <button
            className={clsx(
                'w-full rounded bg-white py-1 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-200 flex justify-center disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none',
                className,
            )}
            {...props}
        >
            {children}
        </button>
    );
}
